import React, { useState } from 'react'
import './Contact.css'
import { 
    TextField,
     Button, 
     Dialog,
      DialogTitle,
      DialogContent,
      DialogActions
    } from '@material-ui/core'
import { contact, API_URL } from '../../constants'
import axios from 'axios'
import { create } from "jss";
import rtl from "jss-rtl";
import { JssProvider } from "react-jss";
import { createGenerateClassName, jssPreset } from "@material-ui/core/styles";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
export default function Contact() {
    return (
        <div className='contact'>
            <div className="contact__top">
            <h1>{contact.title}</h1>
            <button>
                <HighlightOffIcon fontSize='large'/>
            </button>
            </div>
            {/* <Paper className="contact__card" variant="outlined">
                <div className="contact__card__left"> */}
                    <RTL>
                        <ContactForm />
                    </RTL>
                {/* </div>
                <Divider className="divider__component" orientation="vertical" flexItem />
                <div className="contact__card__right">
                    write some
                </div>
            </Paper> */}

        </div>
    )
}


function ContactForm() {
    const [valid, setValid] = useState(false)
    const [fullname, setFullname] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [object ,setObject] = useState('')
    const [demand, setDemand] = useState('')


    const contactButton = (e) => {
        console.log("contact us now ....");
        axios.post(API_URL + '/contacts', {
            fullname: fullname,
            email: email,
            phone: phone,
            object:object,
            demand: demand,
        }).then(res => {

            console.log(res);
        })
      
        // re-init
        setFullname('');
        setEmail('');
        setPhone('');
        setDemand('');

        e.preventDefault()
    }

    const checkValid = () => {
        if (fullname !== '' && email !== '' && phone !== '' && demand) setValid(true);
    }
    return (

        <div className='rdv' dir='rtl'>
            <form className='form'>
                <label>{contact.f1}<span className='req'>*</span></label>
                {checkValid}
                <TextField
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    variant="outlined"
                    dir='rtl' />

                <label>{contact.f2}<span className='req'>*</span></label>
                <TextField
                    alue={email}
                    onChange={(e) => setEmail(e.target.value)}
                    variant="outlined" />

                <label>{contact.f3}<span className='req'>*</span></label>
                <TextField value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    variant="outlined" />

                <label>الموضوع<span className='req'>*</span></label>
                <TextField value={object}
                    onChange={(e) => setObject(e.target.value)}
                    variant="outlined" />


                <label>{contact.f4}<span className='req'>*</span></label>
                <TextField
                    value={demand}
                    onChange={(e) => setDemand(e.target.value)}
                    id="outlined-multiline-static"
                    multiline
                    rows={2}
                    variant="outlined"
                />
                <Button disabled={valid} variant="contained" color="primary" onClick={contactButton}>
                    {contact.action}
                </Button>
            </form>

          

        </div>
    )
}



// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

// Custom Material-UI class name generator.
const generateClassName = createGenerateClassName();

export function RTL(props) {
    return (
        <JssProvider jss={jss} generateClassName={generateClassName}>
            {props.children}
        </JssProvider>
    );
}
